export const environment = {
  uriw: 'https://localhost:7213/',
  uri: 'https://huapangoap.azurewebsites.net/',
  //  uri: 'https://192.168.0.225:5000/',

  production: true
};
